import {
  checkSingleSelectedImage,
  getCanvasDraggingArea,
  getCurrentCanvasData,
  getCurrentLogo,
  getSelectedImage,
  getSideBarWidth,
} from '../canvas/selectors';
import { getAllColorsInUse, getApplyNoticeStatus } from '../userimage/selectors';
import {
  getCurrentHotStampedCheck,
  getCurrentImprintAreaCode,
  getCurrentImprintAreaKey,
  getCurrentImprintProcessType,
  getItemId,
  getItemUseScene7Template,
  getLogoEditingStatus,
  getSelectedTextColor,
  getSidebarTabKey,
  getStudioItemType,
  getTempBackgroundImage,
  getTempBackgroundImageOrigin,
  getVendorId,
} from '../main/selectors';
import {
  getCurrentImprintFormat,
  getDefaultImprintColor,
  getHasOneImprintColorOnly,
  getImprintOptionMaxColorCount,
  getImprintOptionType,
} from '../imprintarea/selectors';

import { createSelector } from 'reselect';
import { getImprintColors } from '../imprintarea/selectors';
import { getIsMultipleArtMultipleColor } from '../nextgen/canvas/selector';
import { getNextgenUiStatus } from '../nextgen/sidebar/LeftFlyout/selectors';
import { studioItemType as studioItemTypeEnum } from '../main/constants';

export const getStoreData = createSelector(
  getCurrentImprintAreaKey,
  getCurrentCanvasData,
  (state) =>
    getStudioItemType(state) === studioItemTypeEnum.digital ? getSelectedImage(state) : getCurrentLogo(state),
  getTempBackgroundImage,
  getVendorId,
  getItemId,
  getLogoEditingStatus,
  getCurrentHotStampedCheck,
  getCanvasDraggingArea,
  getSideBarWidth,
  getCurrentImprintFormat,
  (state) => getImprintColors(state, getCurrentImprintAreaKey(state)),
  getStudioItemType,
  (state) => getHasOneImprintColorOnly(state, getCurrentImprintAreaKey(state)),
  getSidebarTabKey,
  (state) => getSelectedTextColor(state, getCurrentImprintAreaKey(state)),
  (state) => getImprintOptionMaxColorCount(state, getCurrentImprintAreaKey(state)),
  getApplyNoticeStatus,
  (state) => getImprintOptionType(state, getCurrentImprintAreaKey(state)),
  getTempBackgroundImageOrigin,
  checkSingleSelectedImage,
  (state) => getCurrentImprintProcessType(state, getCurrentImprintAreaKey(state)),
  getDefaultImprintColor,
  getItemUseScene7Template,
  getAllColorsInUse,
  getIsMultipleArtMultipleColor,
  getCurrentImprintAreaCode,
  getNextgenUiStatus,
  (
    canvasKey,
    canvasData,
    selectedLogo,
    tempBackground,
    vendorId,
    itemId,
    logoEditingStatus,
    isHotStamped,
    draggingArea,
    sideBarWidth,
    currentImprintFormat,
    imprintColorList,
    studioItemType,
    hasOneImprintColorOnly,
    sidebarTabKey,
    textColor,
    maxColorCount,
    applyNoticeStatus,
    imprintOptionType,
    tempBackgroundOrigin,
    hasSingleSelected,
    processType,
    defaultImprintColor,
    itemUseScene7Template,
    allColorsInUse,
    isMultipleArtMultipleColor,
    imprintAreaCode,
    nextgenUiStatus
  ) => ({
    canvasKey,
    canvasData,
    selectedLogo,
    tempBackground,
    vendorId,
    itemId,
    logoEditingStatus,
    isHotStamped,
    draggingArea,
    sideBarWidth,
    currentImprintFormat,
    imprintColorList,
    hasOneImprintColorOnly,
    studioItemType,
    sidebarTabKey,
    textColor,
    maxColorCount,
    applyNoticeStatus,
    imprintOptionType,
    tempBackgroundOrigin,
    hasSingleSelected,
    processType,
    defaultImprintColor,
    itemUseScene7Template,
    allColorsInUse,
    isMultipleArtMultipleColor,
    imprintAreaCode,
    nextgenUiStatus,
  })
);
